import "./App.css";
import MapView from "./componets/MapView";
function App() {
  return <MapView></MapView>;
}

export default App;
